import React from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

/**
 * The app's share mark (Feather "share-2"). Lifted verbatim from the completed
 * receiving trade card's Share button, which was the only share affordance in
 * the repo, so every share control draws the same glyph.
 */
const ShareIcon: React.FC<Props> = ({ className = '', size = 18, color = 'white' }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

export default ShareIcon;
